/* Koalla — Sammelversand-Schalter im Warenkorb
   Setzt das Cart-Attribut „sammelversand“ und rendert Schubfach bzw.
   Warenkorbseite über Shopifys Section-Rendering neu, so wie Dawns cart.js. */
(() => {
  if (window.__koallaShippingBound) return;
  window.__koallaShippingBound = true;

  const sectionsToRender = () => {
    const list = [];
    if (document.getElementById('CartDrawer')) list.push({ id: 'cart-drawer', selector: '.drawer__inner', root: '#CartDrawer' });
    const items = document.getElementById('main-cart-items');
    if (items?.dataset.id) list.push({ id: items.dataset.id, selector: '.js-contents', root: '#main-cart-items' });
    const footer = document.getElementById('main-cart-footer');
    if (footer?.dataset.id) list.push({ id: footer.dataset.id, selector: '.js-contents', root: '#main-cart-footer' });
    return list;
  };

  // Capture-Phase + stopPropagation: Dawns <cart-items> lauscht ebenfalls auf
  // change und erwartet dann ein Mengenfeld — für unseren Schalter nicht zuständig.
  document.addEventListener('change', async (event) => {
    const box = event.target;
    if (!box.matches?.('[data-koalla-pool]')) return;
    event.stopPropagation();
    const wrap = box.closest('[data-koalla-ship]');
    wrap?.classList.add('k-ship-progress--busy');
    box.disabled = true;
    try {
      const sections = sectionsToRender();
      const res = await fetch(`${window.routes?.cart_update_url || '/cart/update.js'}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { sammelversand: box.checked ? 'ja' : '' }, sections: sections.map((s) => s.id).join(','), sections_url: window.location.pathname }),
      });
      const state = await res.json();
      for (const s of sections) {
        const html = state.sections?.[s.id];
        if (!html) continue;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector(s.selector);
        const target = document.querySelector(`${s.root} ${s.selector}`) || document.querySelector(s.selector);
        if (fresh && target) target.innerHTML = fresh.innerHTML;
      }
    } catch (e) {
      console.error('Sammelversand konnte nicht gespeichert werden', e);
      box.disabled = false;
      wrap?.classList.remove('k-ship-progress--busy');
    }
  }, true);
})();
